import { EventEmitter, Injectable, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranslateConfigService {
  
  @Output()
  currency: EventEmitter<any> = new EventEmitter(true);
  
  constructor(private translateService: TranslateService) {
    let browserLang = navigator.language;
    this.translateService.use('en');
   }
                                                     
   changeLanguage(type: string){
    console.log('type', type);
     this.translateService.use(type);
   }
}
